// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-entity-test',
    // #endregion
    // #region Data
    data: () => ({
        entity: {},
        route: null,
        path: "",
        segments: [],
        content: "",
    }),
    computed: {
        _content() {
            return this.content;
            //return JSON.stringify(this.entity, null, 4);
        }
    },
    // #endregion
    // #region Mounted
    mounted() {
        //this.path = this.$appHost.cookies.getItem("288a.Internal.EntityTest.Path") ?? '/adm/e/order-lists/-/id:d2134fba-9238-47ce-acc0-5894d1e08a9f~accountid:000001/details&w=slide&s=large&l=bottom&b=-2/costcenters/-/000001/details';
    },
    // #endregion
    // #region Run
    methods: {
        getJson(source) {
            return JSON.stringify(source, null, 4);
        },
        update() {
            this.path = this.$route.path;
            let tData1 = this.$appHost.entities.getEntityFromRoute(this.$route);
            {
                this.content = utils.toJsonString(tData1.items, true);
                return;
            }
            //Data
            this.path = this.$route.path;
            this.segments = [];
            // #region Vars
            let tIndex = 0;
            let tCurrent = undefined;
            let tLast = undefined;
            let tEntity = undefined;
            let tDomain = this.$route.params.domain ?? this.$route.meta.domain;
            let tNamespace = this.$route.params.namespace ?? this.$route.meta.namespace;
            let tMeta = this.$route.meta ?? {};
            // #endregion
            // #region Parse
            for (let tSegment of this.$route.params.segement) {
                // #region 0
                if (tIndex === 0) {
                    tCurrent = {
                        entityName: tSegment
                    };
                    this.segments.push(tCurrent);
                }
                // #endregion
                // #region 1
                else if (tIndex == 1) {
                    if (tSegment.indexOf('&') > 0) {
                        tCurrent.viewName = tSegment.substr(0, tSegment.indexOf('&'));
                    }
                    else {
                        tCurrent.viewName = tSegment;
                    }
                }
                // #endregion
                // #region 2
                else if (tIndex == 2) {
                    let tKeys = {};
                    {
                        let tKeyIndex = 1;
                        if (tSegment.indexOf('~') > 0) {
                            for (var tItem of tSegment.split('~')) {
                                if (tItem.indexOf(':') > 0) {
                                    let tArgs = tItem.split(':');
                                    {
                                        tKeys[tArgs[0]] = tArgs[1];
                                    }
                                }
                                else {
                                    tKeys["key" + tKeyIndex] = tItem;
                                }
                                tKeyIndex++;
                            }
                        }
                        else if (tSegment) {
                            if (tSegment.indexOf(':') > 0) {
                                let tArgs = tSegment.split(':');
                                {
                                    tKeys[tArgs[0]] = tArgs[1];
                                }
                            }
                            else {
                                tKeys["key" + tKeyIndex] = tSegment;
                            }
                        }
                        else {
                            tKeys = undefined;
                        }
                    }
                    if (this.segments.length == 1 || this.segments[this.segments.length - 2].keys === undefined) {
                        tCurrent = {
                            entityName: tCurrent?.entityName,
                            keys: tKeys
                        };
                        this.segments.push(tCurrent);
                    }
                    else {
                        tCurrent.keys = tKeys;
                    }
                }
                // #endregion
                // #region 3
                else if (tIndex == 3) {
                    if (tSegment.indexOf('&') > 0) {
                        tCurrent.viewName = tSegment.substr(0, tSegment.indexOf('&'));
                        tCurrent.viewParameter = utils.urlParamsToObject(tSegment.substr(tSegment.indexOf('&') + 1));
                    }
                    else {
                        tCurrent.viewName = tSegment;
                    }
                    tIndex = -1;
                }
                // #endregion
                //Next
                tIndex++;
            }
            // #endregion
            // #region Segemnts
            //Set
            {
                tIndex = 0;
            }
            for (let tSegment of this.segments) {
                // #region View
                if (tSegment.viewName === "-" && tSegment.keys) {
                    tSegment.viewName = "details";
                }
                else {
                    tSegment.viewName = "list";
                }
                if (!tSegment.viewParameter) {
                    tSegment.viewParameter = {};
                }
                // #endregion
                // #region Common
                tSegment.params = tSegment.viewParameter;
                // #endregion                    
                // #region Args
                tSegment.args = {};
                {
                    Object.keys(tSegment.params).forEach(s => {
                        if (s == "w" || s == "l" || s == "s" || s == "id" || s == "m") {
                            return;
                        }
                        tSegment.args[s] = tSegment.params[s];
                    });
                }
                // #endregion
                // #region Entity
                if (!tEntity) {
                    tEntity = {
                        domain: tDomain,
                        namespace: tNamespace,
                        segments: [
                            {
                                name: tSegment.entityName,
                                id: utils.getObjectOrValue(tSegment.keys),
                            }
                        ]
                    };
                }
                else {
                    //Vars
                    let tLast = tEntity.segments[tEntity.segments.length - 1];
                    //Fill
                    if (tLast.name == tSegment.entityName && !tLast.keys && !tLast.id) {
                        tLast.id = utils.getObjectOrValue(tSegment.keys);
                    }
                    else {
                        tEntity.segments.push({
                            name: tSegment.entityName,
                            id: utils.getObjectOrValue(tSegment.keys)
                        });
                    }
                }
                //Set
                {
                    tSegment.entity = utils.cloneDeep(tEntity);
                }
                // #endregion
                // #region Mode
                if (tSegment.viewName.indexOf('~') > 0) {
                    var tViewArgs = tSegment.viewName.split('~');
                    {
                        tSegment.viewName = tViewArgs[0];
                        tSegment.mode = tViewArgs[1];
                    }
                }
                else if (tSegment.params?.m) {
                    tSegment.mode = tSegment.params?.m;
                }
                else if (tSegment.keys) {
                    tSegment.mode = "edit";
                }
                else {
                    tSegment.mode = "list";
                }
                // #endregion
                // #region Navigation
                tSegment.navigation = {
                    id: utils.createId(),
                    mode: tSegment.viewParameter['w'] ?? 'default',
                    location: tSegment.viewParameter['l'],
                    size: tSegment.viewParameter['s'],
                    allowAnonymous: tMeta.allowAnonymous,
                    title: tMeta.title,
                    layout: tMeta.layout,
                    isTest: tMeta.isTest,
                    meta: tMeta,
                    isModal: false,
                    isActive: false,
                    isClosable: tIndex > 0,
                };
                // #endregion
                // #region Component
                // #endregion
                // #region Optimize
                if (tSegment.navigation.mode === 'slide' || tSegment.navigation.mode === 'popup' || tSegment.navigation.mode === 'modal') {
                    tSegment.navigation.isModal = true;
                }
                // #endregion
                // #region Last
                if (!tSegment.navigation.isModal) {
                    tLast = e;
                }
                // #endregion
                tIndex++;
            }
            if (tLast) {
                //Set
                {
                    tLast.navigation.isActive = true;
                }
                for (var i = this.segments.indexOf(tLast); i < tSegments.length; i++) {
                    if (this.segments[i].navigation.isModal) {
                        this.segments[i].navigation.isActive = true;
                    }
                }
            }
            // #endregion
            //mode: tParams.m ? tParams.m : (tParams['id'] ? 'details' : 'list'),
            //name: tEntityName,
            //id: tParams['id'], 
            //path: tSeg.name,
            //query: tArgs,
            //index: tSegments.length,
            //ancestor: [],
            //args: tArgs1,
            //params: tParams,
            //navigation: {
            //    id: utils.createId(),
            //    mode: tParams['w'] ?? 'default',
            //    location: tParams['l'],
            //    size: tParams['s'],
            //    allowAnonymous: m.meta.allowAnonymous,
            //    title: m.meta.title,
            //    layout: m.meta.layout,
            //    meta: m.meta,
            //    isModal: false,
            //    isActive: false,
            //    isTest: m.meta.isTest,
            //    isClosable: false,
            //}
            let tData = {
                route: {
                    name: this.$route.name,
                    href: this.$route.href,
                    fullPath: this.$route.fullPath,
                    path: this.$route.path,
                    query: this.$route.query,
                    hash: this.$route.hash,
                    params: this.$route.params,
                    meta: this.$route.meta,
                },
                segments: this.segments
            };
            this.content = JSON.stringify(tData, null, 4);
            //Cookies
            //this.$appHost.cookies.setItem("288a.Internal.EntityTest.Path", this.path);
            //Parse
            //this.route = router.resolve(this.path)
            //this.entity = appHost.entities.getEntityFromRoute(this.route);
            //if (this.entity.current.root) {
            //this.entity.current.root.root = undefined;
            //}
        },
    }
    // #endregion
});
// #endregion
